import { render, staticRenderFns } from "./DatosContratoForm.vue?vue&type=template&id=b6cf071c"
import script from "./DatosContratoForm.vue?vue&type=script&lang=js"
export * from "./DatosContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports